import businessService from '@/Services/business';
import { getError } from '@/utils/helpers';
import { defineStore } from 'pinia';
import { ref } from 'vue';
import { useContributorStore } from './contributor';
import router from '@/router';

export const useBusinessStore = defineStore('business', () => {
  const business = ref(null),
   bestOfRated = ref(null),
   bestOfVoted = ref(null),
   mostVoted = ref([]),
   topRated = ref([]),
   similarBusinesses = ref([]),
   businesses = ref([]),
   loading = ref(false),
   loadingMostVoted = ref(false),
   loadingTopRated = ref(false),
   loadingContributorTopRated = ref(false),
   loadingSimilarBusinesses = ref(false),
   error = ref(null),
   contributorStore = useContributorStore(),

  setBusiness = async (value) => {
    business.value = value;
  },

  updateBusinessLikeStatusForUser = async () => {
    business.value.liked = !business.value.liked;
    business.value.likeCount += business.value.liked ? 1 : -1;
  },

  updateBusinessBookmarkStatusForUser = async () => {
    business.value.bookmarked = !business.value.bookmarked;
  },

  setBusinesses = async (value) => {
    businesses.value = value;
  },

  updateBusinessesLikeStatusForUser = async (businessId) => {
    const AllBusinessesIndex = businesses.value.findIndex(business => business.id === businessId);    
    if (AllBusinessesIndex !== -1) {
      businesses.value[AllBusinessesIndex].liked = !businesses.value[AllBusinessesIndex].liked;
      businesses.value[AllBusinessesIndex].likeCount += businesses.value[AllBusinessesIndex].liked ? 1 : -1;
    }
    businesses.value.sort((a, b) => b.likeCount - a.likeCount);

    const topRatedIndex = topRated.value.findIndex(business => business.id === businessId);
    if (topRatedIndex !== -1) {
      topRated.value[topRatedIndex].liked = !topRated.value[topRatedIndex].liked;
      topRated.value[topRatedIndex].likeCount += topRated.value[topRatedIndex].liked ? 1 : -1;
    }

    const mostVotedIndex = mostVoted.value.findIndex(business => business.id === businessId);
    if (mostVotedIndex !== -1) {
      mostVoted.value[mostVotedIndex].liked = !mostVoted.value[mostVotedIndex].liked;
      mostVoted.value[mostVotedIndex].likeCount += mostVoted.value[mostVotedIndex].liked ? 1 : -1;
    }
    mostVoted.value.sort((a, b) => b.likeCount - a.likeCount);
  },
    updateSimilarBusinessesLikeStatusForUser = async (businessId) => {
    const similarBusinessesIndex = similarBusinesses.value.findIndex(business => business.id === businessId);    
    if (similarBusinessesIndex !== -1) {
      similarBusinesses.value[similarBusinessesIndex].liked = !similarBusinesses.value[similarBusinessesIndex].liked;
      similarBusinesses.value[similarBusinessesIndex].likeCount += similarBusinesses.value[similarBusinessesIndex].liked ? 1 : -1;
    }
    similarBusinesses.value.sort((a, b) => b.likeCount - a.likeCount);
  },
  updateBusinessCreatorFollowStatus = async () => {
    business.value.creator.authenticatedUserIsFollowing = !business.value.creator.authenticatedUserIsFollowing;
  },

  updateBusinessReviewComments = async (reviewId, comment) => {
    const reviewIndex = business.value.reviews.findIndex(review => review.id === reviewId);
    console.log(reviewIndex, reviewId, comment);
    
    if (reviewIndex !== -1) {
      business.value.reviews[reviewIndex].commentCount += 1;
      business.value.reviews[reviewIndex].comments.unshift(comment)
    }
  },
  updateBusinessReviews = async (review) => {
    business.value.reviews.unshift(review);
    business.value.reviewCount += 1;
  },

  setMostVoted = async (value) => {
    mostVoted.value = value;
  },

  setTopRated = async (value) => {
    topRated.value = value;
  },

  setBestOfVoted = async (value) => {
    bestOfVoted.value = value;
  },

  setBestOfRated = async (value) => {
    bestOfRated.value = value;
  },

  setSimilarBusinesses = async (value) => {
    similarBusinesses.value = value;
  },

  fetchBusinesses = async (sortBy = 'createdAt', orderBy = 'desc') => {
    try {
      loading.value = true;
      const { data } = await businessService.all(sortBy, orderBy),
      businesses = data.data.map((business) =>
        businessService.constructBusiness(business)
      );
      await setBusinesses(businesses);
      await setBusiness(null);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  fetchMostVoted = async (sector = null, category = null) => {
    try {
      loadingMostVoted.value = true;
      let response;
      if (category || sector) {
        if (category) {
          response = await businessService.mostVotedByCategory(category, 6);
        } else {
          response = await businessService.mostVotedBySector(sector, 6);
        }
      } else {
        response = await businessService.mostVoted(6);
      }
      const { data } = response,
      businesses = data.data.map((business) =>
        businessService.constructBusiness(business)
      );
      await setMostVoted(businesses.slice(1, businesses.length));
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loadingMostVoted.value = false;
    }
  },

  fetchTopRated = async (sector = null, category = null) => {
    try {
      loadingTopRated.value = true;
      let response;
      if (sector || category) {
        if (category) {
          response = await businessService.topRatedByCategory(category, 6);
        } else {
          response = await businessService.topRatedBySector(sector, 6);
        }
      } else {
        response = await businessService.topRated(6);
      }
      const { data } = response,
      businesses = data.data.map((business) =>
        businessService.constructBusiness(business)
      );
      await setTopRated(businesses.slice(1, businesses.length));
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loadingTopRated.value = false;
    }
  },

  fetchBestOfVoted = async (sector = null, category = null) => {
    try {
      loadingTopRated.value = true;
      let response;
      if (sector || category) {
        response = (category)
            ? await businessService.mostVotedByCategory(category, 1)
            : await businessService.mostVotedBySector(sector, 1);
      } else {
        response = await businessService.mostVoted(1);
      }
      const { data } = response,
          business = data.data.length
              ? businessService.constructBusiness(data.data[0])
              : null;
      await setBestOfVoted(business);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loadingTopRated.value = false;
    }
  },

  fetchBestOfRated = async (sector = null, category = null) => {
    try {
      loadingTopRated.value = true;
      let response;
      if (sector || category) {
        response = (category)
            ? await businessService.topRatedByCategory(category, 1)
            : await businessService.topRatedBySector(sector, 1);
      } else {
        response = await businessService.topRated(1);
      }
      const { data } = response,
      business = data.data.length
          ? businessService.constructBusiness(data.data[0])
          : null;
      await setBestOfRated(business);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loadingTopRated.value = false;
    }
  },

  fetchBusinessesForSector = async (sector, sortBy = 'createdAt', orderBy = 'desc') => {
    try {
      loading.value = true;
      const { data } = await businessService.forSector(sector, sortBy, orderBy),
      businesses = data.data.map((business) =>
        businessService.constructBusiness(business)
      );
      await setBusinesses(businesses);
      await setBusiness(null);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  fetchBusinessesForCategory = async (sector, category, sortBy = 'createdAt', orderBy = 'desc') => {
    try {
      loading.value = true;
      const { data } = await businessService.forCategory(sector, category, sortBy, orderBy),
      businesses = data.data.map((business) =>
        businessService.constructBusiness(business)
      );
      await setBusinesses(businesses);
      await setBusiness(null);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },

  fetchBusiness = async (sector, category, id) => {
    try {
      loading.value = true;
      const { data } = await businessService.business(sector, category, id),
      business = businessService.constructBusiness(data);
      await setBusiness(business);
      await setBusinesses([]);
      await setMostVoted([]);
      await setTopRated([]);
      await setSimilarBusinesses([]);
      await contributorStore.setTopRatedBusinesses([]);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },
  fetchSimilarBusinesses = async (business) => {
    try {
      loadingSimilarBusinesses.value = true;
      const { data } = await businessService.similarBusinesses(business),
      businesses = data.data.map((business) =>
        businessService.constructBusiness(business)
      );
      await setSimilarBusinesses(businesses);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loadingSimilarBusinesses.value = false;
    }
  },
  
  toggleBusinessLike = async (business, type = 'single') => {
    try {
      loading.value = true;
      await businessService.toggleLike({business_id: business});
      if (type === 'single') {
        await updateBusinessLikeStatusForUser();
        await contributorStore.updateTopBusinessesLikeStatusForUser(business);
      }
      if (type === 'top-rated') {
        await contributorStore.updateTopBusinessesLikeStatusForUser(business);
        await updateBusinessLikeStatusForUser();
      } 
      if (type === 'all') {
        await updateBusinessesLikeStatusForUser(business);
      }
      if (type === 'contributor') {
        await contributorStore.updateBusinessesLikeStatusForUser(business);
      }
      if (type === 'similar') {          
        if (router.currentRoute.value.params.username !== undefined) {                        
          await contributorStore.updateSimilarBusinessesLikeStatusForUser(business);
        } else {            
          await updateSimilarBusinessesLikeStatusForUser(business);
        }
      }
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },
  toggleBookmark = async (business) => {
    try {
      loading.value = true;
      await businessService.toggleBookmark({business_id: business});
      await updateBusinessBookmarkStatusForUser();
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },
  addComment = async (comment) => {
    try {
      loading.value = true;
      const { data } = await businessService.commentReview(comment);
      await updateBusinessReviewComments(comment.review_id, data);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  },
  addReview = async (payload) => {
    try {
      loading.value = true;
      const { data } = await businessService.reviewBusiness(payload);
      await updateBusinessReviews(data);
      error.value = null;
    } catch (err) {
      error.value = getError(err);
    } finally {
      loading.value = false;
    }
  };

  return {
    businesses,
    mostVoted,
    bestOfVoted,
    topRated,
    bestOfRated,
    similarBusinesses,
    business,
    loading,
    loadingMostVoted,
    loadingTopRated,
    loadingSimilarBusinesses,
    loadingContributorTopRated,
    error,
    setBusiness,
    setBusinesses,
    setMostVoted,
    setBestOfVoted,
    setTopRated,
    setBestOfRated,
    setSimilarBusinesses,
    updateBusinessLikeStatusForUser,
    updateBusinessesLikeStatusForUser,
    updateBusinessCreatorFollowStatus,
    updateSimilarBusinessesLikeStatusForUser,
    updateBusinessBookmarkStatusForUser,
    updateBusinessReviewComments,
    updateBusinessReviews,
    fetchBusinesses,
    fetchBusinessesForSector,
    fetchBusinessesForCategory,
    fetchBusiness,
    fetchMostVoted,
    fetchBestOfVoted,
    fetchTopRated,
    fetchBestOfRated,
    fetchSimilarBusinesses,
    toggleBusinessLike,
    toggleBookmark,
    addComment,
    addReview,
  };
});
